/**
 * @generated SignedSource<<308274c015b883e3913f7b809c9db9c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_viewer$data = {
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly klarnaNegotiationEnabled: boolean | null;
  readonly klarnaOnSiteMessagingEnabled: boolean | null;
  readonly pdpOptinPromptFF: boolean | null;
  readonly showHeartCount: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerChatLoader_viewer" | "PdpRespDealerDetails_viewer" | "PdpRespDetailTabs_viewer" | "PdpRespDetailsTabs_viewer" | "PdpRespIconBubblesWrapper_viewer" | "PdpRespPersonalizedItemsCarouselLazy_viewer" | "PdpRespSellerItemsCarousel_viewer" | "PdpRespSharedHeroCarousel_viewer" | "PdpRespSidebarBlurbs_viewer" | "PdpRespSimilarAuctionItemsLazy_viewer" | "PdpRespSimilarItemsCarousel_viewer" | "PdpRespYMALItemsCarousel_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedRestrictedMaterialsLoader_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "PdpRespContainer_viewer";
};
export type PdpRespContainer_viewer$key = {
  readonly " $data"?: PdpRespContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isRespTabsRedesignVariant"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_viewer",
  "selections": [
    {
      "alias": "klarnaOnSiteMessagingEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "KLARNA_OSM"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"KLARNA_OSM\")"
    },
    {
      "alias": "klarnaNegotiationEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "klarnaNegotiationFlow"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"klarnaNegotiationFlow\")"
    },
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "alias": "showHeartCount",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpDisplayHeartCount"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpDisplayHeartCount\")"
    },
    {
      "alias": "pdpOptinPromptFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpOptinPrompt"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpOptinPrompt\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespYMALItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespPersonalizedItemsCarouselLazy_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsCarousel_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemsCarousel_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarousel_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespIconBubblesWrapper_viewer"
        }
      ]
    },
    {
      "condition": "isRespTabsRedesignVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerDetails_viewer"
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRestrictedMaterialsLoader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailsTabs_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarAuctionItemsLazy_viewer"
        }
      ]
    },
    {
      "condition": "isRespTabsRedesignVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDetailTabs_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "07c3dbbef8ef4f94ef01b049cbc7c172";

export default node;
